import * as React from 'react';

import { getCurrentPartFIO } from './getCurrentPartFIO';
import { getQueryIndex } from './getQueryIndex';
import { setSuggest } from './setSuggest';
import { getFillProgress } from './getFillProgress';
import { EGender, TSetSuggestFiltered, TSetSuggestPart, TGetFIOSuggest } from '../../../types/fio';

export interface IUseOnFocusHandler {
  inputValue: string;
  gender: EGender;
  setSuggestFiltered: TSetSuggestFiltered;
  setSuggestPart: TSetSuggestPart;
  getFIOSuggest: TGetFIOSuggest;
}

export function useOnFocusHandler({
  inputValue,
  gender,
  setSuggestFiltered,
  setSuggestPart,
  getFIOSuggest,
}: IUseOnFocusHandler) {
  return React.useCallback(() => {
    const inputSplitValue = inputValue.split(' ');
    const currentPartFIO = getCurrentPartFIO(inputValue.split(' ').filter(Boolean));
    const queryIndex = getQueryIndex(currentPartFIO);
    const { isAfterSurnameSpaceSymbol, isAfterNameSpaceSymbol, isFIOFinished } = getFillProgress(inputSplitValue);

    if (isAfterSurnameSpaceSymbol || isAfterNameSpaceSymbol || isFIOFinished) {
      return;
    }

    setSuggest({
      inputSplitValue,
      currentPartFIO,
      queryIndex,
      gender,
      setSuggestFiltered,
      setSuggestPart,
      getFIOSuggest,
    });
  }, [gender, inputValue, setSuggestFiltered, setSuggestPart, getFIOSuggest]);
}
